import { create } from 'zustand';
import {
  IKurvBasicInformationFormValues,
  IKurvAccountProcessingFormValues,
  IKurvBusinessComplianceFormValues,
  IKurvSalesAndTransactionsFormValues,
  IKurvEquipmentFormValues,
} from '../main/merchant-offers/KurvForm/validation';

export interface KurvFormSlice {
  basicInformation?: IKurvBasicInformationFormValues;
  accountProcessing?: IKurvAccountProcessingFormValues;
  businessCompliance?: IKurvBusinessComplianceFormValues;
  salesAndTransactions?: IKurvSalesAndTransactionsFormValues;
  equipment?: IKurvEquipmentFormValues;

  setBasicInformation: (data: IKurvBasicInformationFormValues) => void;
  setAccountProcessing: (data: IKurvAccountProcessingFormValues) => void;
  setBusinessCompliance: (data: IKurvBusinessComplianceFormValues) => void;
  setSalesAndTransactions: (data: IKurvSalesAndTransactionsFormValues) => void;
  setEquipment: (data: IKurvEquipmentFormValues) => void;
}

export const kurvFormSlice = create<KurvFormSlice>()((set, get) => ({
  basicInformation: undefined,
  accountProcessing: undefined,
  businessCompliance: undefined,
  salesAndTransactions: undefined,
  equipment: {
    eComAuthNet: false,
    eComConvenuePay: false,
    eComIHaveMyOwn: false,
    retailDejavooZ8: false,
    retailDejavooZ9: false,
    retailKurvMobileB200: false,
    retailKurvMobileB250: false,
    retailIHaveMyOwn: false,
  },

  setBasicInformation: (basicInformation: IKurvBasicInformationFormValues) =>
    set({ basicInformation }),
  setAccountProcessing: (accountProcessing: IKurvAccountProcessingFormValues) =>
    set({ accountProcessing }),
  setBusinessCompliance: (businessCompliance: IKurvBusinessComplianceFormValues) =>
    set({ businessCompliance }),
  setSalesAndTransactions: (salesAndTransactions: IKurvSalesAndTransactionsFormValues) =>
    set({ salesAndTransactions }),
  setEquipment: (equipment: IKurvEquipmentFormValues) => set({ equipment }),
}));
